import { connect } from 'react-redux'
import * as actions from '../actions'
import ListName from './ListName'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingListDetails: state.contacts.isFetchingListDetails,
    list: state.contacts.list,
    ...ownProps
  }
}

const mapDispatchToProps = dispatch => ({
  fetchListDetails: (token, id) =>
    dispatch(actions.fetchListDetails(token, id)),
  deleteContactList: (token, id) =>
    dispatch(actions.deleteContactList(token, id)),
  addPerson: (token, name, email, role, id) =>
    dispatch(actions.addPerson(token, name, email, role, id)),
  editPerson: (token, name, email, role, listId, id) =>
    dispatch(actions.editPerson(token, name, email, role, listId, id)),
  deletePerson: (token, listId, id) =>
    dispatch(actions.deletePerson(token, listId, id)),
  updateContactList: (token, name, id) =>
    dispatch(actions.updateContactList(token, name, id)),
  csvUpload: (token, file, contactId, validation) =>
    dispatch(actions.csvUpload(token, file, contactId, validation))
})

const ListNameContainer = connect(mapStateToProps, mapDispatchToProps)(
  ListName
)

export default ListNameContainer



// WEBPACK FOOTER //
// ./src/routes/Contacts/ListName/ListNameContainer.js